"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = __importDefault(require("lodash"));
DashboardController.$inject = ['$scope', '_dashboard', 'notify', 'storage', '$interval', '_trip'];
function DashboardController($scope, _dashboard, notify, storage, $interval, _trip) {
    var self = this;
    var refresh_interval = 10000; //10 seconds
    $scope.panel_open = false;
    $scope.hasNewMessage = false;
    $scope.messageLocation = {};
    $scope.dirOptions = {};
    $scope.refreshMap = function () {
        $scope.dirOptions.refreshMap();
    };
    if (storage.getItem('autoloadMsg') !== null) {
        $scope.autoloadMsg = storage.getItem('autoloadMsg');
    }
    else {
        $scope.autoloadMsg = 1;
        storage.setItem('autoloadMsg', 1);
    }
    $scope.setAutoloadMsg = function () {
        $scope.autoloadMsg = $scope.autoloadMsg === 1 ? 0 : 1;
        storage.setItem('autoloadMsg', $scope.autoloadMsg);
    };
    $scope.toggleMenuItem = function (item) {
        $scope.widgets[item] = !$scope.widgets[item];
    };
    $scope.togglePanel = function () {
        if ($scope.hasNewMessage && !$scope.panel_open) {
            $scope.getLastMessages();
        }
        $scope.panel_open = $scope.panel_open === true ? false : true;
    };
    $scope.newMessage = function () {
        _dashboard.newMessage().then(function (response) {
            _dashboard.saveMessage(response.id, { status: 1 }).then(function (response) {
                notify.success('You sucessfuly send the message.');
                $scope.getLastMessages();
            });
        }, function (error) {
            notify.error('Message not sent.');
            console.log(error);
        });
    };
    function fetchMessages() {
        _dashboard.fetchMessages().then(function (response) {
            _trip.fetchShips().then(function (ships) {
                lodash_1.default.each(response, function (val) {
                    var ship = lodash_1.default.find(ships, { si: val.si });
                    if (!lodash_1.default.isEmpty(ship)) {
                        val.s_name = ship.name;
                    }
                });
                $scope.messages = response;
            });
        }, function (error) {
            console.log(error);
        });
    }
    $scope.getLastMessages = function () {
        var last_message = lodash_1.default.maxBy($scope.messages, function (m) {
            return m.id;
        });
        _dashboard.getLastMessages(last_message.id).then(function (response) {
            _trip.fetchShips().then(function (ships) {
                lodash_1.default.each(response, function (val) {
                    var ship = lodash_1.default.find(ships, { si: val.si });
                    if (!lodash_1.default.isEmpty(ship)) {
                        val.s_name = ship.name;
                    }
                    $scope.messages.push(val);
                });
                $scope.hasNewMessage = false;
            });
        }, function (error) {
            console.log(error);
        });
    };
    var interval = $interval(function () {
        var last_message = lodash_1.default.maxBy($scope.messages, function (m) {
            return m.id;
        });
        _dashboard.checkNewMessages(last_message.id).then(function (response) {
            if (response.total > 0) {
                if (!$scope.panel_open) {
                    $scope.hasNewMessage = true;
                }
                else {
                    if ($scope.autoloadMsg === 1) {
                        _dashboard.getLastMessages(last_message.id).then(function (response) {
                            lodash_1.default.each(response, function (m) {
                                $scope.messages.push(m);
                            });
                        }, function (error) {
                            console.log(error);
                        });
                    }
                    else {
                        $scope.hasNewMessage = true;
                    }
                }
            }
        }, function (error) {
            console.log(error);
        });
    }, refresh_interval);
    $scope.$on('$destroy', function () {
        $interval.cancel(interval);
    });
    $scope.setStatus = function (status, message) {
        _dashboard.saveMessage(message.id, { status: status }).then(function (response) {
            notify.success('You have successfully saved the data.');
            message.status = status;
        }, function (error) {
            notify.error(error.data);
            console.log(error);
        });
    };
    $scope.locateMessage = function (message) {
        if (message.si != 0 && (message.lon != 0 || message.lat != 0)) {
            var color = null;
            if (message.severity == 0) {
                color = '#a6a6a6';
            }
            if (message.severity == 1) {
                color = '#e6c615';
            }
            if (message.severity == 2) {
                color = '#d42d24';
            }
            $scope.messageLocation = {
                lon: message.lon,
                lat: message.lat,
                si: message.si,
                color: color
            };
        }
        else {
            $scope.messageLocation = {};
        }
    };
    fetchMessages();
}
exports.DashboardController = DashboardController;



//////////////////
// WEBPACK FOOTER
// ./scripts/apps/dashboard/controllers/DashboardController.ts
// module id = 474
// module chunks = 0